var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"html-editor"},[_c('vue-editor',{ref:"editor",attrs:{"editor-options":_vm.toolbarOptions,"disabled":_vm.disabled,"useCustomImageHandler":""},on:{"text-change":_vm.updateValue,"imageAdded":_vm.uploadImage},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }